// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d2c63f92","453":"08b535f5","667":"8da3b4d4"}[chunkId] + ".chunk.js";
};